import { LanguageKey } from "@/providers/LocalizationProvider";
import { CONFIGS } from "@/constants/configs";

export const IS_DEV = process.env.NODE_ENV === "development";

/**
 * Supported languages in the application
 */
export const SUPPORTED_LANGUAGES: LanguageKey[] = CONFIGS.i18n.supportedLanguages as unknown as LanguageKey[];

/**
 * Default language - configured via NEXT_PUBLIC_FALLBACK_LANGUAGE env variable
 */
export const DEFAULT_LANGUAGE: LanguageKey = CONFIGS.i18n.defaultLanguage as LanguageKey;


/**
 * Jalali (Persian) month names
 */
export const JALALI_MONTHS: Record<string, string> = {
  "01": "فروردین",
  "02": "اردیبهشت",
  "03": "خرداد",
  "04": "تیر",
  "05": "مرداد",
  "06": "شهریور",
  "07": "مهر",
  "08": "آبان",
  "09": "آذر",
  "10": "دی",
  "11": "بهمن",
  "12": "اسفند",
};
